import { render } from "./ViewTrade.vue?vue&type=template&id=d7da50cc"
import script from "./ViewTrade.vue?vue&type=script&lang=js"
export * from "./ViewTrade.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__